import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes } from 'react';
export type FormErrorsProps = {
  children?: unknown;
  className?: string;
} & Omit<HTMLAttributes<HTMLSpanElement>, 'children'>;
const FormErrors = t0 => {
  const $ = _c(3);
  const {
    children,
    className
  } = t0;
  if (typeof children === "string") {
    const t1 = `text-error text-caption-2 ${className} fp-form-errors fp-custom-appearance`;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
      t2 = <span className={t1}>{children}</span>;
      $[0] = children;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  return null;
};
export default FormErrors;